import React from "react";
import logo from '../../assets/images/logo.png'
import { useNavigate } from "react-router-dom";

const Footer = () => {
	const navigate = useNavigate();

	return (
		<>

			<footer className="bg-footer- footer-content-wgt">
				<div className="footer-top pb-3">
					<div className="container">
						<div className="row">
							<div className="col-12 col-md-6 col-lg-3">
								<div className="footer-logo"><img src={logo} alt="" /><span>GOMYFOOD</span></div>
								{/* <p className="text-white ftr-short-disc">Get free website for your shop and bring it online with ownezzy : A professional shopping website provider. Start selling online today !</p> */}
							</div>
							<div className="col-12 col-md-6 col-lg-2">
								<div className="footer-wigit-area">
									<h3 className="title-wgt-ftr">Company</h3>
									<ul className="list-sp-tr">
										<li className="menu-item-link"><a href="#" className="link-ftr-web">Home</a></li>
										<li className="menu-item-link"><a href="#" className="link-ftr-web">Products</a></li>
										<li className="menu-item-link"><a href="#" className="link-ftr-web">About Us</a></li>
										<li className="menu-item-link"><a href="#" className="link-ftr-web">Blogs</a></li>
									</ul>
								</div>
							</div>
							<div className="col-12 col-md-6 col-lg-3">
								<div className="footer-wigit-area">
									<h3 className="title-wgt-ftr">Support</h3>
									<ul className="list-sp-tr">
										<div onClick={() => navigate('/contact-us')}  className="menu-item-link">Contact Us </div>
										<div onClick={() => navigate('/privacy-policy')}  className="menu-item-link">Privacy Policy </div>
										<div onClick={() => navigate('/terms-conditions')}  className="menu-item-link">Terms & Conditions 	 </div>		
										<div onClick={() => navigate('/refund-policy')}  className="menu-item-link">Cancellation & Refund Policy </div>

									</ul>
								</div>
							</div>
							<div className="col-12 col-md-6 col-lg-4">
								<div className="footer-wigit-area">
									<h3 className="title-wgt-ftr">Contact Info</h3>
									<div className="list-contact">
										<ul>
											<li><a href="tel:916287370656">Phone No. +91-8309060700</a></li>
											<li><a href="mailto:grocerydeliverygomyfood@gmail.com">Email: grocerydeliverygomyfood@gmail.com</a></li>
										</ul>
									</div>
									<div className="social-wigit">
										<ul className="list-social-wgt">
											<li className="item-list-social"><a href="#" target="_blank"><i
												className="fab fa-facebook-f"></i></a></li>
											<li className="item-list-social"><a href="#" target="_blank"><i
												className="fab fa-youtube"></i></a></li>
											<li className="item-list-social"><a href="#" target="_blank"><i
												className="fab fa-instagram"></i></a></li>
											<li className="item-list-social"><a href="#" target="_blank"><i
												className="fab fa-twitter"></i></a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-bottom">
					<div className="container">
						<div className="row">
							<div className="col-12">
								<p className="mb-0 text-white text-center">© 2023 ownezzy - All rights reserved</p>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
export default Footer;